module.exports = __webpack_public_path__ + "img/hp-awp-fire.42aad75e.png";